export default "__VITE_ASSET__Qn6dWODA__"